<template>
  <div>
    <h1>Mapa de localización</h1>
    <TravelMap/>
  </div>
</template>
<script>
import TravelMap from '../../components/maps/travelMap/TravelMap'
export default {
  name: 'Maps',
  components: {
    TravelMap,
  },
}
</script>
